import React from 'react';

import { InternalViewTabName } from 'common/subdomain/admin/v2/AdminV2IdeaSheet/InternalView/IdeaTabs';
import { IdeaSheetQueryParams } from 'common/subdomain/admin/v2/AdminV2IdeasTableV2/constants';

import Link from '../Link';
import PostLink from '../post/PostLink';

import type { Notification } from 'common/api/endpoints/notifications';

type Props = {
  notification: Notification;
  onTap?: () => void;
  children: React.ReactNode;
};

const NotificationLink = ({ notification, onTap, children }: Props) => {
  const post = notification.post || notification.comment?.post;

  // Handle idea comment notifications
  if (notification?.ideaComment) {
    const ideaURL = `/admin/ideas?idea=${notification.ideaComment.idea.urlName}&${IdeaSheetQueryParams.IdeaTab}=${InternalViewTabName.Activity}`;
    return (
      <Link to={ideaURL} onTap={onTap}>
        {children}
      </Link>
    );
  }

  return (
    <PostLink post={post} onTap={onTap}>
      {children}
    </PostLink>
  );
};

export default NotificationLink;
